// Pluggz external Supabase browser client.
// URL + anon key are publishable values — safe to hardcode.
import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://kzdhvepwoytrhyjlriju.supabase.co";
const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt6ZGh2ZXB3b3l0cmh5amxyaWp1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEwMTc1MjEsImV4cCI6MjA5NjU5MzUyMX0.JZiBIXiixTKF8VuviLSEMSjqNuEQGMuJeRmBHQ0xuc8";

export const supabase: SupabaseClient = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: { persistSession: true, autoRefreshToken: true, storageKey: "pluggz-auth" },
});